// ========================================================================================
/*
    arrayType         [staff || radiology || jobs ] - if need another - create in appointmentFilters file
    selectedStatuses  [arr]
    onChange          [func]
 */
// ========================================================================================


import React, { useEffect } from 'react';
import { translate } from 'react-i18next';

// Constants
import { sortStatusArray } from './appointmentFilters';

// Components
import { SelectField } from 'components/Fields';

// Styles & Images
import s from './AppointmentStatusFilter.style';


const renderValueItem = translate()(({ t }) => {
  return (
    <s.ValueItemWrapper>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
          <path fill="#A2A4B2" fillRule="nonzero"
            d={`M8 13h16v-2H8v2zm0 9h16v-2H8v2zM8 2v2h16V2H8zM0 0v6h6V0H0zm4 4H2V2h2v2zM0 
            15h6V9H0v6zm2-4h2v2H2v-2zM0 24h6v-6H0v6zm2-4h2v2H2v-2z`} />
        </g>
      </svg>

      <p>{t('view_appointments')}</p>
    </s.ValueItemWrapper>
  );
});


const AppointmentStatusFilter = (props) => {
  const { arrayType, onChange, selectedStatuses, t } = props;

  useEffect(() => {
    // Init appointments statuses
    if (!selectedStatuses && arrayType) {
      
      const prepareArray = [];
      sortStatusArray(arrayType).forEach(item => {
        if (item.defaultActive) { prepareArray.push(item.conditions); }
      });
      onChange(prepareArray);
    }
  }, []);

  const renderDropDown = () => {
    const isActive = appoint => {
      if (selectedStatuses && appoint && appoint.conditions) {
        return selectedStatuses.some(el => String(el) === String(appoint.conditions));
      }
    };

    return (
      <s.CustomList>
        {sortStatusArray(arrayType).map(filterItem => (
          <s.CustomItem
            key={filterItem && filterItem.translateLabel}
            active={isActive(filterItem)}
            bottomLine={filterItem.bottomLine}
            onClick={() => {
              if (onChange) onChange(filterItem.conditions);
            }}
          >
            <p>{t(filterItem && filterItem.translateLabel && filterItem.translateLabel.toLowerCase())}</p>
            <span />
          </s.CustomItem>
        ))}
      </s.CustomList>
    );
  };

  return (
    <s.FilterWrapper className="appoint-status-filter-wrapper">
      <SelectField
        className="select-field appoint-status-filter"
        valueComponent={renderValueItem}
        messages={{ emptyList: renderDropDown() }}
      />
    </s.FilterWrapper>
  );
};

export default translate()(AppointmentStatusFilter);
